import React, {useState, useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {QRCodeCanvas} from 'qrcode.react';
import './MemberCode.css';
import brandHeaderImage from './assets/images/brand-header.png'; // 导入品牌标题图片
import vipIconImage from './assets/images/vip-icon.png'; // 导入 VIP 图标
import wechatPayImage from './assets/images/wechat-pay.png'; // 导入微信支付图标
import reloadIconImage from './assets/images/reload-icon.png'; // 导入重新加载图标
import dividerImage from './assets/images/divider.png'; // 导入分隔线图片
import { getMemberInfo, activateCode } from './services/activationService'; // 导入激活码相关服务
import Modal from './components/Modal'; // 导入模态框组件

function MemberCode() {
  const [timestamp, setTimestamp] = useState(Date.now());
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [memberId, setMemberId] = useState('');
  const [memberInfo, setMemberInfo] = useState(null);
  const [error, setError] = useState('加载中...');
  const [showModal, setShowModal] = useState(false);
  const [pendingCode, setPendingCode] = useState('');
  const code = searchParams.get('code');

  const updateTimestamp = () => {
    const newTimestamp = Date.now();
    setTimestamp(newTimestamp);
    console.log(`二维码更新时间戳: ${newTimestamp}`);
  };

  // 时间戳刷新器
  useEffect(() => {
    // 自动每100秒刷新二维码
    const timer = setInterval(() => {
      updateTimestamp();
    }, 30000); // 100秒 = 100000毫秒
    console.log('当前定时器: ', timer);
    return () => clearInterval(timer);
  }, []);

  const handleInitMemberInfo = () => {
    if (!code) {
      setError('链接有误，请复制完整')
      return
    }
    // 初始化
    setError("加载中...")

    const fetchMemberInfo = async () => {
      try {
        // // 先检查激活码是否有效
        // const activationInfo = await checkActivationCode(code);
        // console.log('激活码信息:', activationInfo);

        // 获取会员信息
        const info = await getMemberInfo(code);
        console.log('会员信息:', info);

        // 如果查询成功，则更新 memberId
        if (info && info.member_id) {
          setMemberId(info.member_id);
          setMemberInfo(info);
          setError(''); // 清除错误信息
          updateTimestamp(); // 更新时间戳
        }
      } catch (error) {
        console.error('获取会员信息失败:', error);
        if (error.message === '该激活码尚未激活' || error.message === '该会员码尚未激活') {
          // 显示模态框让用户确认是否需要激活
          setPendingCode(code);
          setShowModal(true);
        } else {
          setError(error.message || '获取会员信息失败');
        }
      }
    };

    // 加载会员信息
    fetchMemberInfo()
  };

  // 首次加载
  useEffect(handleInitMemberInfo, [code]);

  const handleActivateCode = async () => {
    try {
      setShowModal(false);
      // 调用激活接口
      await activateCode(pendingCode);
      // 激活成功后重新获取会员信息
      const info = await getMemberInfo(pendingCode);
      if (info && info.member_id) {
        setMemberId(info.member_id);
        setMemberInfo(info);
        setError('');
        updateTimestamp(); // 更新时间戳
      }
    } catch (error) {
      console.error('激活失败:', error);
      setError(error.message || '激活失败');
    }
  };

  const reloadCode = () => {
    console.log('点击重新加载');
    updateTimestamp();
    // 在实际应用中，这里可能还需要调用 API
  };

  const goToWeChatPay = () => {
    console.log('跳转到微信支付');
    // 在实际应用中，这里会处理跳转逻辑
    window.location.href = 'weixin://widget/pay'; // 添加跳转逻辑
  };

  const goToActivation = () => {
    navigate('/activate');
  };

  const qrCodeValue = `${memberId}_${timestamp}`;

  return (
    <div className="member-code-container">
      {/* 顶部导航栏 */}
      <div className="header">
        <div className="header-left">
          {/*<span onClick={goToActivation} style={{cursor: 'pointer'}}>*/}
          {/*  激活会员*/}
          {/*</span>*/}
          <span onClick={goToActivation}>&#x1F3E0;</span>
        </div>
        <div className="header-title">会员码</div>
        <div className="header-right">
          <span>...</span> {/* 更多选项图标 */}
          <span>&#x25CE;</span> {/* 目标图标 */}
        </div>
      </div>

      {/* 用户信息 */}
      <div className="user-info">
        <div className="user-name-line">
          <span className="user-name">{memberInfo?.name || '华仔先生呀呀呀'}</span>
          <span className="super-member-badge">
            <img src={vipIconImage} alt="超级荟员" style={{height: '23px', width: 'auto'}}/>
          </span>
        </div>
        <div className="user-desc-info">
          <div className="store-info">荟品仓：品牌特卖 荟选好物</div>
          {
            memberId &&
            <div className="expire-info">超级荟员 {memberInfo?.expires_at || '未'}到期</div>
          }
        </div>
      </div>

      {/* 二维码卡片 */}
      <div className="code-card">
        {error && (
          <div className="qr-code-mask">
            <div className="qr-code-mask-text">
              {error}
            </div>

            {/* 添加刷新按钮 */}
            {
              !["加载中...", "链接有误，请复制完整"].includes(error) && (
                <button className="modal-button reload-button" onClick={handleInitMemberInfo}>刷 新</button>
              )
            }
          </div>
        )}
        <div>
          <div className="brand-header">
            <img src={brandHeaderImage} alt="Himaxx | 荟品仓"/>
          </div>
          <div className="member-id">{memberId}</div>
          <div className="qr-code-wrapper" onClick={updateTimestamp}>
            <QRCodeCanvas value={qrCodeValue} size={220} level={'H'} includeMargin={true}/>
          </div>
          <div className="reload-section" onClick={reloadCode}>
            <span className="reload-icon">
              <img src={reloadIconImage} alt="" style={{width: '12px', height: 'auto'}}/>
            </span>
            <span>重新加载</span>
          </div>
        </div>
        <div className="divider">
          <img src={dividerImage} alt="---" style={{width: '100%', height: 'auto'}}/>
        </div>
        <div onClick={goToWeChatPay}>
          <div className="wechat-pay-icon">
            <img src={wechatPayImage} alt="" style={{width: '28px', height: 'auto'}}/>
          </div>
          <div className="wechat-pay-button">
            <span>去使用微信支付 &gt;</span>
          </div>
        </div>
      </div>

      {/* 激活确认模态框 */}
      <Modal
        isOpen={showModal}
        onClose={() => {
          setError('尚未激活，无法使用')
          setShowModal(false);
        }}
        title="激活确认"
        onConfirm={handleActivateCode}
      >
        <p>该会员码尚未激活，是否立即激活？</p>
      </Modal>
    </div>
  );
}

export default MemberCode;
